var map = {
	"./pages/admin/admin.module.ngfactory": [
		"ecMe",
		4
	],
	"./pages/ed/ed.module.ngfactory": [
		"uxcC",
		5
	],
	"./pages/profile/profile.module.ngfactory": [
		"y8fh",
		6
	],
	"./settings/settings.module.ngfactory": [
		"zJ2U",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;